import * as React from "react";
const SvgFiRrThoughtBubble = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-thought-bubble_svg__a)">
      <path
        fill="#062147"
        d="M3 22.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 3 22.5M6 17a2 2 0 1 0-.001 3.999A2 2 0 0 0 6 17m17.962-6.315c-.258 2.315-1.949 4.343-4.207 5.044a5.74 5.74 0 0 1-3.452.014.93.93 0 0 0-.817.12 5.9 5.9 0 0 1-3.485 1.138 5.98 5.98 0 0 1-5.071-2.794.53.53 0 0 0-.424-.257 5.5 5.5 0 0 1-.702-.068C2.627 13.237.555 10.21 1.085 6.99c.382-2.333 2.179-4.27 4.472-4.817a6.1 6.1 0 0 1 2.583-.062 1 1 0 0 0 .852-.276 6.44 6.44 0 0 1 4.51-1.833 6.51 6.51 0 0 1 5.918 3.826c.112.247.335.442.627.548a5.98 5.98 0 0 1 3.917 6.311zm-4.598-4.43c-.804-.291-1.431-.861-1.768-1.605A4.5 4.5 0 0 0 13.5 2a4.45 4.45 0 0 0-3.116 1.269 2.96 2.96 0 0 1-2.625.805 4 4 0 0 0-.758-.072 3.975 3.975 0 0 0-3.943 3.313C2.704 9.469 4.083 11.493 6.2 11.92c.088.018.238.024.396.031a2.53 2.53 0 0 1 2.023 1.187A3.99 3.99 0 0 0 12 15.001c.831 0 1.63-.261 2.308-.755a2.95 2.95 0 0 1 2.584-.415c.746.23 1.508.226 2.27-.012 1.512-.469 2.642-1.817 2.812-3.355a3.99 3.99 0 0 0-2.609-4.208z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-thought-bubble_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrThoughtBubble;
